export default __webpack_public_path__ + "static/Euclid Circular A SemiBold-ae11344face2a74d2042b9561fc67249.ttf";